export default __webpack_public_path__ + "static/media/Le chemin d'une vie.c4c2258c.jpg";